import { ContractorModelAPI, EmployeeNodeModel } from '../../../../models';
import { getContractorsListAdapter } from '../../Adapters';
import { requests } from '../apiAgent';

export const ContractorsAPI = {
    getContractors: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/contractors/list')
            .then((response: ContractorModelAPI[]) =>
                getContractorsListAdapter(response)
            );
    },

    getEmployeeByContractors: (contractorId: number) => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/contractors/get-employees-contractor/' +
                    contractorId
            )
            .then((response: EmployeeNodeModel[]) => response);
    },
};
